import { LinearProgressBarCoreDriver } from './LinearProgressBarCore/LinearProgressBarCore.driver';

export interface LinearProgressBarDriver extends LinearProgressBarCoreDriver {
  isErrorIconShown: () => boolean;
  isSuccessIconShown: () => boolean;
  getTooltipErrorMessage: () => string;
}
